/**
 * HemSyd Favoriter — sido-panel (drawer). Kräver hs-fav-shared.js + hs-favorites.js.
 *
 * OBS om "Köp alla favoriter"-knappens summa: buyAllOriginalText är en
 * HTML-snapshot från sidladdningen där #hsFavDrawerTotal innehåller "0 kr".
 * Varje gång innerHTML återställs från snapshoten skapas en NY span - därför
 * måste totalEl hämtas om OCH summan skrivas in EFTER återställningen
 * (restoreBuyAllLabel), aldrig före. Tidigare version satte summan först och
 * återställde innerHTML efteråt -> knappen visade alltid "0 kr".
 *
 * A11y (2026-07-14): open()/close() togglar inert + aria-hidden i par (se
 * snippets/hs-favorites-drawer.liquid). Vid close blurras ev. fokus inuti
 * panelen först - aria-hidden/inert på ett element som innehåller
 * document.activeElement är i sig ett tillgänglighetsfel.
 */
(function () {
  'use strict';

  var CHECK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';

  var drawer, backdrop, list, closeBtn, countEl, footer, totalEl, buyAllBtn;
  var buyAllOriginalText = '';
  var currentProducts = [];
  var lastTotalFormatted = '0 kr';

  function els() {
    drawer = document.getElementById('hsFavDrawer');
    backdrop = document.getElementById('hsFavDrawerBackdrop');
    list = document.getElementById('hsFavDrawerList');
    closeBtn = document.getElementById('hsFavDrawerClose');
    countEl = document.getElementById('hsFavDrawerCount');
    footer = document.getElementById('hsFavDrawerFooter');
    totalEl = document.getElementById('hsFavDrawerTotal');
    buyAllBtn = document.getElementById('hsFavDrawerBuyAll');
    if (buyAllBtn) buyAllOriginalText = buyAllBtn.innerHTML;
  }

  // Återställer knapp-HTML från snapshot och skriver in senaste summan i den
  // NYA #hsFavDrawerTotal-spannen som återställningen skapar.
  function restoreBuyAllLabel() {
    if (!buyAllBtn) return;
    buyAllBtn.innerHTML = buyAllOriginalText;
    totalEl = document.getElementById('hsFavDrawerTotal');
    if (totalEl) totalEl.textContent = lastTotalFormatted;
  }

  function render() {
    if (!list) return;
    list.innerHTML = '<p class="hsFavEmpty">Laddar...</p>';

    window.HSFavShared.fetchFavorites().then(function (items) {
      if (!items.length) {
        list.innerHTML = '<p class="hsFavEmpty">Du har inga favoriter än.</p>';
        countEl.textContent = '(0)';
        footer.hidden = true;
        updateHeaderBadge(0);
        return;
      }
      window.HSFavShared.fetchProducts(items).then(function (products) {
        currentProducts = products;
        list.innerHTML = '';
        products.forEach(function (p) {
          list.appendChild(window.HSFavShared.buildDrawerRow(p));
        });
        countEl.textContent = '(' + products.length + ')';
        updateHeaderBadge(products.length);

        var total = products.reduce(function (sum, p) {
          var v = p.variants && p.variants[0];
          var available = v ? v.available : p.available;
          var price = v ? v.price : p.price;
          return sum + (available ? price : 0);
        }, 0);
        lastTotalFormatted = window.HSFavShared.money(total);
        restoreBuyAllLabel();
        footer.hidden = false;
      });
    });
  }

  function updateHeaderBadge(count) {
    document.querySelectorAll('.hsFavBadge').forEach(function (badge) {
      badge.textContent = count;
      badge.hidden = count === 0;
    });
  }

  function open() {
    if (!drawer) els();
    if (window.HSCartDrawer) window.HSCartDrawer.close();
    drawer.classList.add('is-open');
    backdrop.classList.add('is-open');
    drawer.removeAttribute('aria-hidden');
    drawer.removeAttribute('inert');
    document.documentElement.classList.add('hsFavDrawerOpen');
    document.body.classList.add('hsFavDrawerOpen');
    render();
  }

  function close() {
    if (!drawer) return;
    if (document.activeElement && drawer.contains(document.activeElement)) {
      document.activeElement.blur();
    }
    drawer.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    document.documentElement.classList.remove('hsFavDrawerOpen');
    document.body.classList.remove('hsFavDrawerOpen');
  }

  function buyAll() {
    if (buyAllBtn.disabled) return;

    var items = currentProducts
      .filter(function (p) {
        var v = p.variants && p.variants[0];
        return v ? v.available : p.available;
      })
      .map(function (p) {
        var v = p.variants && p.variants[0];
        return { id: v ? v.id : p.variant_id, quantity: 1 };
      });

    if (!items.length) return;

    buyAllBtn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        window.HSFavShared.refreshCartBadge();
        buyAllBtn.innerHTML = CHECK_SVG;
        setTimeout(function () {
          restoreBuyAllLabel();
          buyAllBtn.disabled = false;
        }, 1500);
      })
      .catch(function () {
        buyAllBtn.disabled = false;
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    els();
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (backdrop) backdrop.addEventListener('click', close);
    if (buyAllBtn) buyAllBtn.addEventListener('click', buyAll);

    document.querySelectorAll('[data-hs-fav-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    });

    document.addEventListener('hs:fav:changed', function (e) {
      updateHeaderBadge(e.detail.count);
    });
  });

  window.HSFavoritesDrawer = { open: open, close: close };
})();
